
import React from 'react';

import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';


interface Props {
    callback;
}

interface State {

}

export class MenuComponent extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

    }

    render() {
        let items = [
            {
                label: 'Design',
                icon: 'pi pi-fw pi-pencil',
                command: (e) => {
                    this.props.callback({
                        displayDesign: true,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: false
                    })
                }
            },
            {
                label: 'Preview',
                icon: 'fa fa-eye',
                command: (e) => {
                    this.props.callback({
                        displayDesign: false,
                        displayPreview: true,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: false
                    })
                }
            },
            // {
            //     label: 'Publish',
            //     icon: 'pi pi-fw pi-file-export',
            //     command: (e) => {
            //         this.props.callback({
            //             displayDesign: false,
            //             displayPreview: false,
            //             displayPublish: true,
            //             displaySave: false,
            //             displayDownload: false
            //         })
            //     }
            // },
            {
                label: 'Save',
                icon: 'pi pi-fw pi-save',
                command: (e) => {

                    this.props.callback({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: true,
                        displayDownload: false
                    })
                }
            },
            {
                label: 'Upload',
                icon: 'pi pi-fw pi-upload',
                command: (e) => {
                    this.props.callback({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayUpload: true,
                        displayDownload: false
                    })
                }
            },
            {
                label: 'Download Layout',
                icon: 'pi pi-fw pi-download',
                command: (e) => {
                    this.props.callback({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: true
                    })
                }
            },
            {
                label: 'Download Payload JSON',
                icon: 'pi pi-fw pi-download',
                command: (e) => {
                    this.props.callback({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: false,
                        displayDownloadPayload: true
                    })
                }
            },
            {
                label: 'Download PDF',
                icon: 'pi pi-fw pi-download',
                command: (e) => {
                    this.props.callback({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: false,
                        displayDownloadPayload: false,
                        displayDownloadPDF: true
                    })
                }
            },
        ];

        if (process.env.IS_RUNTIME == "true") {
            items = [
                {
                    label: 'Save as Draft',
                    icon: 'pi pi-fw pi-save',
                    command: (e) => {

                        this.props.callback({
                            displayDesign: false,
                            displayPreview: false,
                            displayPublish: false,
                            displaySave: true,
                            displayDownload: false
                        })
                    }
                },
                {
                    label: 'Submit',
                    icon: 'pi pi-fw pi-server',
                    command: (e) => {
                        this.props.callback({
                            displayDesign: false,
                            displayPreview: false,
                            displayPublish: false,
                            displaySave: false,
                            displaySubmit: true,
                            displayDownload: false
                        })
                    }
                },

                {
                    label: 'Download PDF',
                    icon: 'pi pi-fw pi-download',
                    command: (e) => {
                        this.props.callback({
                            displayDesign: false,
                            displayPreview: false,
                            displayPublish: false,
                            displaySave: true,
                            displayDownload: false,
                            displayDownloadPDF: true
                        })
                    }
                },
            ];
        }

        return (
            <div className="card sticky">
                {/* @ts-ignore */}
                <Menu model={items}></Menu >
            </div>
        )
    }

}
